import { Grid } from "@material-ui/core";
import MeditocInfoNumber from "../../../utils/MeditocInfoNumber";
import MeditocTable from "../../../utils/MeditocTable";
import { getConektaColumns } from "../../../../models/ReporteVentaModel";
import { useReporteVenta } from "../../../../context/ReporteVentaContext";

export default function Conekta() {
    const { ordenSeleccionada, resumenVentasConekta, handleChangeOrdenSeleccionada } = useReporteVenta();

    return (
        resumenVentasConekta && (
            <Grid container spacing={3}>
                <Grid item md={3} sm={6} xs={12} className="center">
                    <MeditocInfoNumber
                        label="TOTAL DE VENTA"
                        value={
                            "$" +
                            resumenVentasConekta.dTotalVendido.toLocaleString("en", {
                                minimumFractionDigits: 2,
                            })
                        }
                        color="color-1"
                    />
                </Grid>
                <Grid item md={3} sm={6} xs={12} className="center">
                    <MeditocInfoNumber
                        label="ÓRDENES VENDIDAS"
                        value={resumenVentasConekta.iTotalOrdenes}
                        color="color-6"
                    />
                </Grid>
                <Grid item md={3} sm={6} xs={12} className="center">
                    <MeditocInfoNumber
                        label="ÓRDENES RECHAZADAS"
                        value={resumenVentasConekta.iTotalOrdenesRechazadas}
                        color="color-5"
                    />
                </Grid>
                <Grid item md={3} sm={6} xs={12} className="center">
                    <MeditocInfoNumber
                        label="FOLIOS GENERADOS"
                        value={resumenVentasConekta.iTotalFolios}
                        color="color-3"
                    />
                </Grid>
                <Grid item xs={12}>
                    <MeditocTable
                        columns={getConektaColumns()}
                        data={resumenVentasConekta.lstOrdenes}
                        row={ordenSeleccionada}
                        setRow={handleChangeOrdenSeleccionada}
                        id="sOrderId"
                    />
                </Grid>
            </Grid>
        )
    );
}
